let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '车辆品牌名称',
        props: 'vehicleBrand',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
    {
        label: '状态',
        props: 'status',
        minWidth: 300,
        formatter:(row)=>{
            if(row.status == '01'){
                return '启用'
            }else if(row.status == '02'){
                return '禁用'
            }
        }
    },
    {
        label: '创建人',
        props: 'createdByName',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '更新人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '更新时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
   
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '车辆基础信息管理'
},
{
    type: 'title',
    name: '车辆品牌管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'pileTypeNo',
    editRouter: 'VehicleBrandDetail',
};

// 路由
pageConfig.listRouter = 'brandList';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '车辆基础信息管理',
},
{
    type: 'router',
    name: '车辆品牌管理',
    router: 'brandList'
},
{
    type: 'title',
    name: '车辆品牌详情',
},
];

pageConfig.formRules = {
    vehicleBrand: [{
        required: true,
        message: '请填写车辆品牌',
        trigger: 'blur'
    }],
    status: [{
        required: true,
        message: '请选择状态',
        trigger: 'change'
    }],
};



export default pageConfig;
